export default __webpack_public_path__ + "static/media/stripe_payment.e65b9432.svg";